import { CLONOTYPES_LOADING, CLONOTYPES_LOADED, CLONOTYPES_ERROR } from 'redux/actionTypes/clonotypes';
import { QC_FINISHED } from 'redux/actionTypes/global';
import initialState from 'redux/reducers/clonotypes/initialState';
import clonotypesLoading from 'redux/reducers/clonotypes/clonotypesLoading';
import clonotypesLoaded from 'redux/reducers/clonotypes/clonotypesLoaded';
import clonotypesError from 'redux/reducers/clonotypes/clonotypesError';
import qcFinished from 'redux/reducers/clonotypes/qcFinished';
var clonotypesReducer = function clonotypesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case CLONOTYPES_LOADING:
      {
        return clonotypesLoading(state, action);
      }
    case CLONOTYPES_LOADED:
      {
        return clonotypesLoaded(state, action);
      }
    case CLONOTYPES_ERROR:
      {
        return clonotypesError(state, action);
      }
    case QC_FINISHED:
      {
        return qcFinished(state, action);
      }
    default:
      {
        return state;
      }
  }
};
export default clonotypesReducer;